import { AirgapAPI, type TrackingConsentDetails } from '@transcend-io/airgap.js-types';
import { MouseEvent } from 'react';
import { ConsentOptions } from '@transcend-io/airgap.js-types/build/core';
import { AirgapPurposes } from 'src/types.ts';

/**
 * Set consent selections.
 *
 * @param airgapApi An instance of the AirgapAPI.
 * @param event The AirgapAuth event.
 * @param optInPersonalizedAdvertising Boolean answer to opt in to personalized advertising.
 */
export const confirmMyChoices = async (
    airgapApi: AirgapAPI,
    event: MouseEvent<HTMLButtonElement> | null,
    isCanada: boolean,
    optInPersonalizedAdvertising: boolean,
    optInAnalytics: boolean = true,
    optInFunctional: boolean = true
): Promise<[boolean, TrackingConsentDetails]> => {
    const newConsent: TrackingConsentDetails = airgapApi.getConsent();

    newConsent.purposes[AirgapPurposes.SaleOfInfo] = optInPersonalizedAdvertising;
    // support more features if CA
    if (isCanada) {
        newConsent.purposes[AirgapPurposes.Analytics] = optInAnalytics;
        newConsent.purposes[AirgapPurposes.Functional] = optInFunctional;
    }
    const consentOptions = {
        confirmed: true,
        prompted: true,
        timestamp: new Date().toISOString(),
        waitForSync: true,
    } as ConsentOptions;
    const setConsentResult = await airgapApi.setConsent(event !== null ? event.nativeEvent : null, newConsent.purposes, consentOptions);
    return Promise.resolve([ setConsentResult, newConsent ]);
};
